import React, { useEffect, useState } from "react";
import {
  Between,
  CheckValidInputs,
  Label,
  LineShrink,
  LabelBig,
  LabelNumric,
  LabelSmall,
  Signature,
  StepBody,
  StepFooter,
  useInput,
  Row,
} from "meitav-uikit";
import utils from "utils";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";
import { postData, setDataLayer } from "../../../../../utils/Functions";
import Footer from "components/Footer";
import { Parser } from "html-to-react";
import "./step33.scss";
import { isMobile } from "react-device-detect";
const { UmbracoUtills, rest } = utils;

export default function Step33({
  resource,
  model,
  setModel,
  setStep,
  step,
  dataList,
  nextText,
  setDataList,
  resourceError,
  disable,
}) {
  const resourceStep = UmbracoStep(resource, `SecondSub3Step`);
  const p = new Parser();

  const [bank, setBank] = useState({});
  const [branch, setBranch] = useState({});

  const myCond = {
    empty: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorEmptyField"),
      cond: (value) => value === "",
    },
  };

  const signature = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "signature"),
    model.paymentDetails?.signature,
    [myCond.empty]
  );

  useEffect(() => {
    getPaymentsDetails();
  }, []);

  const getPaymentsDetails = async () => {
    if (dataList.banks.length == 0) {
      const res = await rest.get(`/api/general/GetBankList`);
      const res2 = await rest.get(`/api/general/GetBranchesList`);

      let tmpList = { ...dataList };
      tmpList.banks = res?.data;
      tmpList.branches = res2?.data;
      setDataList(tmpList);
      localStorage.setItem("dataList", JSON.stringify(tmpList));
    }
  };

  useEffect(() => {
    if (model.paymentDetails.depositBankNum) {
      setBank(
        dataList.banks.find(
          (x) => x.BankID === model.paymentDetails.depositBankNum
        )
      );
    }
    if (model.paymentDetails.depositBankSnif) {
      setBranch(
        dataList.branches.find(
          (x) =>
            x.BankId === model.paymentDetails.depositBankNum &&
            x.BranchNum === model.paymentDetails.depositBankSnif
        )
      );
    }
  }, [dataList]);

  const handleNext = async () => {
    if (disable) {
      setStep(41);
      return;
    }
    if (!CheckValidInputs([signature])) {
      return;
    }
    setDataLayer(
      "PM - bank deposit",
      window.location.pathname,
      "הרשאת חיוב חשבון",
      "המשך מוצלח של שלב חתימה על חיוב חשבון"
    );
    let tmpModel = model;
    tmpModel.paymentDetails.signature = signature.value;
    tmpModel.currentStepID = 33;
    tmpModel.stepID = 41;
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    setDataLayer(
      "PM - Levels",
      "/JoinPersonalDetails",
      "חזור לשלב הקודם",
      "חזרה - " + step
    );

    let tmpModel = model;
    tmpModel.paymentDetails.signature = signature.value;
    setModel(tmpModel);
    setStep(32);
  };

  return (
    <div className="step33">
      <StepBody>
        <Row>
          <Row type="small">
            <Label>
              {UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "textSum")}
            </Label>
            <LabelNumric
              prefix="₪"
              size="big"
              addClass="special-bold"
              text={model.paymentDetails.depositSum}
            />
          </Row>
          <div className="hr"></div>
          <Row type="small">
            <LabelBig>
              {UmbracoUtills.getParsedHtmlValueByKey(
                resourceStep,
                "detailsAccount"
              )}
            </LabelBig>
            <Row className="box">
              <Between>
                <Row type="shrink">
                  <LabelSmall>
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resourceStep,
                      "bank"
                    )}
                  </LabelSmall>
                  <Label addClass="special">{`${bank?.BankID} - ${bank?.BankName}`}</Label>
                </Row>
                <Row type="shrink">
                  <LabelSmall>
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resourceStep,
                      "branch"
                    )}
                  </LabelSmall>
                  <Label addClass="special">{`${branch?.BranchNum} - ${branch?.BranchName}`}</Label>
                </Row>
              </Between>
              <Between>
                <Row type="shrink">
                  <LabelSmall>
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resourceStep,
                      "accountNum"
                    )}
                  </LabelSmall>
                  <Label addClass="special">
                    {model.paymentDetails.depositBankAccountNum}
                  </Label>
                </Row>
                <Row type="shrink">
                  <LabelSmall>
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resourceStep,
                      "accountFullName"
                    )}
                  </LabelSmall>
                  <Label addClass="special">
                    {model.paymentDetails.depositBankAccountFullName}
                  </Label>
                </Row>
              </Between>
            </Row>
          </Row>

          <div className="hr"></div>
          {model.paymentDetails.permitionTypeId == "1" && (
            <Row className="box">
              <Label>
                {UmbracoUtills.getParsedHtmlValueByKey(
                  resourceStep,
                  "permisionAll"
                )}
              </Label>
            </Row>
          )}
          {model.paymentDetails.permitionTypeId == "2" && (
            <Row className="box">
              <Between>
                <Row type="shrink">
                  <LabelSmall>
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resourceStep,
                      "permisionRestriction"
                    )}
                  </LabelSmall>
                  <LineShrink className="restriction">
                    <LabelSmall addClass="special">
                      {UmbracoUtills.getParsedHtmlValueByKey(
                        resourceStep,
                        "permisionSum"
                      )}
                    </LabelSmall>
                    <LabelSmall addClass="special">
                      {model.paymentDetails.restrictionMaxSum}
                    </LabelSmall>
                  </LineShrink>
                </Row>
                <Row type="shrink">
                  <LabelSmall>
                    {UmbracoUtills.getParsedHtmlValueByKey(
                      resourceStep,
                      "permisionRestriction"
                    )}
                  </LabelSmall>
                  <LineShrink className="restriction">
                    <LabelSmall addClass="special">
                      {UmbracoUtills.getParsedHtmlValueByKey(
                        resourceStep,
                        "permisonDate"
                      )}
                    </LabelSmall>
                    <LabelSmall addClass="special">
                      {model.paymentDetails.restrictionUntillDate}
                    </LabelSmall>
                  </LineShrink>
                </Row>
              </Between>
            </Row>
          )}
          <Row>
            <Label>
              {UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "sign")}
            </Label>
            <Signature
              width={isMobile ? "300" : "600"}
              height="200"
              {...signature}
              disable={disable}
            />
          </Row>
        </Row>
      </StepBody>
      <StepFooter
        nextText={nextText}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
      <Footer
        text={p.parse(UmbracoUtills.getValueByKey(resourceStep, "mainText"))}
      ></Footer>
    </div>
  );
}
